const ReviewStarsBlocksFunction = () => {
  const blocks = document.querySelectorAll('.reviews_stars');

  if(blocks.length > 0) {
    blocks.forEach(block => {
      const stars = block.querySelectorAll('.star-svg');
      let rating = block.dataset.rating ? parseFloat(block.dataset.rating) : 5;
      let remainder = 0;
      
      if(rating % 1 !== 0) {
        remainder = 1.0 - (rating % 1);
        rating = Math.floor(rating)
      }
    
      if(rating < 5) {
        stars.forEach((star, index) => {
          if(index >= rating) {
            const starWidth = star.width.baseVal.value;
            const starIndicator = star.querySelector('.star-indicator');
            
            if(index === rating && remainder > 0) {
              starIndicator.style.transform = `translateX(${(starWidth * remainder) * -1}px)`;
            } else {
              starIndicator.style.transform = `translateX(${starWidth * -1}px)`;
            }
          }
        })
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', ReviewStarsBlocksFunction);